export default "__VITE_ASSET___yx2oVV3__"